import { render } from "./VideoLightbox.vue?vue&type=template&id=6f58476b&scoped=true"
import script from "./VideoLightbox.vue?vue&type=script&lang=js"
export * from "./VideoLightbox.vue?vue&type=script&lang=js"

import "./VideoLightbox.vue?vue&type=style&index=0&id=6f58476b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f58476b"]])

export default __exports__